import { Button, Dimmer, DimmerDimmable, Form, Loader, Modal } from '@mairistem/composants';
import { request } from '@mairistem/tools';
import _ from 'lodash';
import React from 'react';
import { REGISSEUR } from '@/constants';
import { getPayeurs, getUsers } from '@/routes';
import type { ApiResponseType, UtilisateurType } from '@/types';

import { UtilisateurListeTable } from '../../Utilisateur';
import FormRegisseur from './FormRegisseur';
// "Fausses" data en attendant de setup le service utilisateur, utilisé que en dev local
import fakeUsers from './utilisateurs';

const ModalRegisseurs = (props) => {
  const { onClose, onSelect, regisseurs, ...rest } = props;

  const [loading, setLoading] = React.useState(false);
  const [users, setUsers] = React.useState<UtilisateurType[]>();
  const [selected, setSelected] = React.useState();
  const [mandat, setMandat] = React.useState(0);
  const [actif, setActif] = React.useState(true);

  const handleSelect = React.useCallback((item) => {
    setSelected(item);
  }, []);

  const handleFormChange = React.useCallback((name, value) => {
    if (name === 'mandat') {
      setMandat(value);
    }

    if (name === 'actif') {
      setActif(value);
    }
  }, []);

  React.useEffect(() => {
    setLoading(true);
    // todo mettre en place le service utilisateurs
    const get = process.env.NODE_ENV === 'development' ? getPayeurs : getUsers;
    const pendingPromises = [];

    request.get(get()).then(({ data, meta: { lastPage } }: ApiResponseType<UtilisateurType>) => {
      for (let i = 2; i <= lastPage; i += 1) {
        pendingPromises.push(request.get(get({ page: i, perPage: 50 })));
      }

      Promise.all(pendingPromises)
        .then((datas) => {
          let dataFormatted: UtilisateurType[] = data;

          _.forEach(datas, ({ data: d }) => {
            dataFormatted = [...dataFormatted, ...d];
          });

          let utilisateurs = dataFormatted;

          if (process.env.NODE_ENV === 'development') {
            utilisateurs = fakeUsers;
          }

          setUsers(
            _.filter(
              utilisateurs,
              ({ login }) =>
                _.toLower(login) !== 'adminonline' &&
                _.toLower(login) !== 'jvs' &&
                _.toLower(login) !== 'admin' &&
                _.toLower(login) !== 'administrateur',
            ),
          );
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, []);

  /** Utilisateurs éligibles pour être régisseur
   * (ceux qui le sont déjà ne doivent pas être dans la liste) */
  const usersEligibleRegisseur = React.useMemo(
    () =>
      _.filter(users, ({ identifiant }) => !_.some(regisseurs, { identifiantLogin: identifiant })),
    [regisseurs, users],
  );

  return (
    <Modal closeIcon open size="tiny" onClose={onClose} {...rest}>
      <Modal.Header>Ajout d&apos;un régisseur ou d&apos;un mandataire</Modal.Header>
      <Modal.Content>
        <DimmerDimmable as={Form} dimmed={loading}>
          <Dimmer active={loading} inverted>
            <Loader inverted content="Chargement" />
          </Dimmer>
          <FormRegisseur
            actif={actif}
            mandat={mandat}
            onChange={handleFormChange}
            loading={loading}
          />
          <UtilisateurListeTable
            items={usersEligibleRegisseur}
            onSelect={handleSelect}
            loading={loading}
            selected={selected}
          />
        </DimmerDimmable>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-close"
          onClick={() => onClose()}
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          loading={loading}
          disabled={loading}
        />
        <Button
          data-testid="button-validate"
          positive
          onClick={() => onSelect(selected, REGISSEUR.TYPES[mandat], actif)}
          disabled={_.isEmpty(selected) || loading}
          content="Sélectionner"
          icon="checkmark"
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalRegisseurs;
